export default __webpack_public_path__ + "static/2-8ae81350850c43e43267ff868cd39ea9.png";